export default "__VITE_ASSET__Co8_p8Wt__"